<script lang="ts">
  import { currentMode } from '../lib/state';
  import type { TravelMode } from '../lib/types';

  const tabs: { mode: TravelMode; label: string }[] = [
    { mode: 'WALKING', label: 'Walk' },
    { mode: 'BICYCLING', label: 'Bike' },
    { mode: 'TRANSIT', label: 'Transit' },
    { mode: 'DRIVING', label: 'Drive' },
  ];
</script>

<div class="mode-tabs" role="tablist" aria-label="Travel mode for breakdown">
  {#each tabs as t}
    <button
      class="mode-tab"
      class:active={$currentMode === t.mode}
      role="tab"
      aria-selected={$currentMode === t.mode}
      on:click={() => currentMode.set(t.mode)}
    >{t.label}</button>
  {/each}
</div>
